import {Component, Input} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCircleExclamation} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-error-alert',
  imports: [FaIconComponent],
  templateUrl: './error-alert.component.html'
})
export class ErrorAlertComponent {
  @Input() title?: string;
  @Input() message = 'Грешка';

  get messageLines(): string[] {
    return this.message
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(Boolean);
  }

  protected readonly faCircleExclamation = faCircleExclamation;
}
